import React, { useState, useEffect, useRef } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';

const PRODUCT_LINKS = [
  { to: '/products/20l-jar', label: 'Vijaya Varshi 20L Jar', icon: '&#x1FAA3;', img: '/products/jar-20l.png?v=2', desc: '&#x20B9;60 / refill', tag: 'Best Seller' },
  { to: '/products/1l-bottle', label: 'Vijaya Varshi 1L Bottle', icon: '&#x1F376;', img: '/products/bottle-1l.png?v=2', desc: '&#x20B9;20 / bottle', tag: null },
  { to: '/products/500ml-bottle', label: 'Vijaya 500ml Bottle', icon: '&#x1FAD9;', img: '/products/bottle-500ml.png?v=2', desc: '&#x20B9;10 / bottle', tag: null },
  { to: '/products/250ml-bottle', label: 'Vijaya 250ml Bottle', icon: '&#x1F4A7;', img: '/products/bottle-250ml.png?v=2', desc: '&#x20B9;6 / bottle', tag: null },
];

export default function PublicLayout() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [dropOpen, setDropOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const dropRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropRef.current && !dropRef.current.contains(e.target)) {
        setDropOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    setDropOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const isActive = (path, exact) => exact ? location.pathname === '/' : location.pathname.startsWith(path);

  const linkStyle = (active) => ({
    padding: '0.45rem 0.85rem',
    borderRadius: '8px',
    fontSize: '0.9rem',
    fontWeight: active ? 700 : 500,
    color: active ? '#C8171A' : '#374151',
    background: active ? '#FEF4F4' : 'transparent',
    transition: 'all 0.15s',
    textDecoration: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>

      {/* Top Bar */}
      <div className="pub-topbar" style={{ background: '#C8171A', padding: '0.45rem 1.5rem', fontSize: '0.8rem', color: 'rgba(255,255,255,0.9)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>Call us: <strong>+91 8374422411</strong>&nbsp;&nbsp;|&nbsp;&nbsp;Email: <strong>support@vijayavarshi.com</strong></span>
        <span>Mon–Sun 6AM–8PM&nbsp;&nbsp;|&nbsp;&nbsp;Same-Day Delivery Hyderabad</span>
      </div>

      {/* Navbar */}
      <nav style={{
        background: 'white',
        borderBottom: scrolled ? '1px solid #e2e8f0' : '1px solid #FFF8F8',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        boxShadow: scrolled ? '0 2px 12px rgba(200,23,26,0.08)' : 'none',
        transition: 'all 0.25s',
      }}>
        <div className="page-container pub-navbar-inner" style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>

          {/* Logo */}
          <Link to="/" className="pub-logo-link" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            <img src="/Vijaya_Varshi_Logo_V13.png" alt="Vijaya Varshi" className="pub-logo-img" />
          </Link>

          {/* Desktop Nav Links */}
          <div className="nav-desktop-links" style={{ display: 'flex', alignItems: 'center', gap: '0.15rem', marginLeft: 'auto' }}>
            <Link to="/" style={linkStyle(isActive('/', true))}>Home</Link>

            {/* Products Dropdown */}
            <div ref={dropRef} style={{ position: 'relative' }}>
              <button
                onClick={() => setDropOpen(o => !o)}
                style={{ ...linkStyle(isActive('/products', false)), background: dropOpen ? '#FEF4F4' : (isActive('/products', false) ? '#FEF4F4' : 'transparent'), border: 'none', cursor: 'pointer', fontFamily: 'inherit' }}
              >
                Products <span style={{ fontSize: '0.6rem', marginLeft: '0.2rem', opacity: 0.7, display: 'inline-block', transition: 'transform 0.2s', transform: dropOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>&#9660;</span>
              </button>
              {dropOpen && (
                <div style={{ position: 'absolute', top: 'calc(100% + 8px)', left: '50%', transform: 'translateX(-50%)', background: 'white', border: '1px solid #e2e8f0', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.12)', minWidth: 250, padding: '0.4rem', zIndex: 300 }}>
                  <div style={{ padding: '0.5rem 0.85rem 0.35rem', fontSize: '0.7rem', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.07em' }}>
                    Our Products
                  </div>
                  {PRODUCT_LINKS.map(pl => (
                    <Link key={pl.to} to={pl.to} className="dropdown-item" onClick={() => setDropOpen(false)}>
                      <span style={{ flexShrink: 0, width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img src={pl.img} alt={pl.label} onError={e => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'inline'; }} style={{ maxWidth: 34, maxHeight: 34, objectFit: 'contain' }} />
                        <span style={{ display: 'none', fontSize: '1.35rem' }} dangerouslySetInnerHTML={{ __html: pl.icon }} />
                      </span>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 600, fontSize: '0.84rem', color: '#1e293b', lineHeight: 1.2 }}>{pl.label}</div>
                        <div style={{ fontSize: '0.73rem', color: '#6b7280', marginTop: '0.1rem' }} dangerouslySetInnerHTML={{ __html: pl.desc }} />
                      </div>
                      {pl.tag && (
                        <span style={{ background: '#FDE8E8', color: '#C8171A', borderRadius: '9999px', padding: '0.15rem 0.5rem', fontSize: '0.65rem', fontWeight: 700, flexShrink: 0 }}>
                          {pl.tag}
                        </span>
                      )}
                    </Link>
                  ))}
                  <div className="dropdown-divider" />
                  <Link to="/products" className="dropdown-item" style={{ fontWeight: 700, color: '#C8171A', justifyContent: 'center' }} onClick={() => setDropOpen(false)}>
                    View All Products &#8594;
                  </Link>
                </div>
              )}
            </div>

            <Link to="/about" style={linkStyle(isActive('/about', false))}>About</Link>
            <Link to="/gallery" style={linkStyle(isActive('/gallery', false))}>Gallery</Link>
            <Link to="/contact" style={linkStyle(isActive('/contact', false))}>Contact</Link>
          </div>

          {/* Desktop Right Side (Login hidden) */}

          {/* Mobile Hamburger */}
          <button className={'nav-hamburger' + (menuOpen ? ' is-open' : '')} onClick={() => setMenuOpen(o => !o)} aria-label="Toggle menu">
            <span /><span /><span />
          </button>
        </div>

        {/* Mobile Nav Panel */}
        <div className={'mobile-nav-panel' + (menuOpen ? ' is-open' : '')}>
          <Link to="/" className={'mobile-nav-link' + (location.pathname === '/' ? ' active' : '')}>
            <span>Home</span>
            <span className="mobile-nav-chev">&#8250;</span>
          </Link>

          <div className="mobile-nav-section">Our Products</div>
          {PRODUCT_LINKS.map(pl => (
            <Link key={pl.to} to={pl.to} className={'mobile-nav-sub' + (location.pathname === pl.to ? ' active' : '')}>
              <span className="mobile-nav-sub-thumb">
                <img src={pl.img} alt={pl.label} onError={e => { e.target.style.display = 'none'; }} />
              </span>
              <div className="mobile-nav-sub-body">
                <div className="mobile-nav-sub-title">{pl.label}</div>
                <div className="mobile-nav-sub-price" dangerouslySetInnerHTML={{ __html: pl.desc }} />
              </div>
              {pl.tag && <span className="mobile-nav-sub-tag">{pl.tag}</span>}
            </Link>
          ))}
          <Link to="/products" className="mobile-nav-all">
            View All Products <span>&#8594;</span>
          </Link>

          <div className="mobile-nav-divider" />

          <Link to="/about" className={'mobile-nav-link' + (location.pathname === '/about' ? ' active' : '')}>
            <span>About</span><span className="mobile-nav-chev">&#8250;</span>
          </Link>
          <Link to="/gallery" className={'mobile-nav-link' + (location.pathname === '/gallery' ? ' active' : '')}>
            <span>Gallery</span><span className="mobile-nav-chev">&#8250;</span>
          </Link>
          <Link to="/contact" className={'mobile-nav-link' + (location.pathname === '/contact' ? ' active' : '')}>
            <span>Contact</span><span className="mobile-nav-chev">&#8250;</span>
          </Link>

          <div className="mobile-nav-contact">
            <a href="tel:8374422411" className="mnc-call">
              <span>&#x260E;</span> Call us
            </a>
            <a href="https://wa.me/918374422411" target="_blank" rel="noreferrer" className="mnc-wa">
              <span>&#x1F4AC;</span> WhatsApp
            </a>
          </div>

          <div className="mobile-nav-footer">
            Mon&ndash;Sun &middot; 6:00 AM &ndash; 8:00 PM &middot; Hyderabad
          </div>
        </div>
      </nav>

      {/* Page Content */}
      <main style={{ flex: 1 }}>
        <Outlet />
      </main>

      {/* Pre-Footer CTA */}
      <div style={{ background: 'linear-gradient(160deg, #FFF8F8 0%, #FDE8E8 100%)', borderTop: '1px solid #fecaca', padding: '2.75rem 1.5rem' }}>
        <div className="page-container"><div className="pre-footer-inner">
          <div>
            <div style={{ marginBottom: '0.4rem' }}>
              <h3 style={{ fontWeight: 800, color: '#0c1a2e', fontSize: '1.3rem', margin: 0 }}>
                Get pure water delivered to your door
              </h3>
            </div>
            <p style={{ color: '#6b7280', fontSize: '0.9375rem', margin: 0 }}>
              Same-day delivery across Hyderabad. Order by 10 AM, delivered today.
            </p>
          </div>
          <div style={{ display: 'flex', gap: '0.875rem', flexWrap: 'wrap', flexShrink: 0 }}>
            <a href="tel:8374422411" style={{ background: '#C8171A', color: 'white', padding: '0.75rem 1.5rem', borderRadius: '10px', fontWeight: 700, fontSize: '0.9375rem', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
              Call 8374422411
            </a>
            <a href="https://wa.me/918374422411" target="_blank" rel="noreferrer" style={{ background: '#16a34a', color: 'white', padding: '0.75rem 1.5rem', borderRadius: '10px', fontWeight: 700, fontSize: '0.9375rem', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
              WhatsApp Us
            </a>
          </div>
        </div></div>
      </div>

      {/* Footer */}
      <footer style={{ background: '#0c1a2e', color: '#94a3b8' }}>

        {/* Main Footer Grid */}
        <div className="page-container" style={{ padding: '3.5rem 1.5rem 2.5rem' }}>
          <div className="footer-grid">

            {/* Brand Column */}
            <div>
              {/* Logo */}
              <div style={{ marginBottom: '1.25rem' }}>
                <div style={{ background: 'white', borderRadius: '10px', display: 'inline-block', padding: '6px 10px' }}>
                  <img src="/Vijaya_Varshi_Logo_V13.png" alt="Vijaya Varshi" style={{ height: 80, objectFit: 'contain', display: 'block' }} />
                </div>
              </div>

              <p className="text-justify" style={{ fontSize: '0.875rem', lineHeight: 1.8, marginBottom: '1.5rem', color: '#94a3b8' }}>
                Delivering pure, safe drinking water to homes and businesses across Hyderabad since 2026. Trusted by 1,000+ families.
              </p>

              {/* Cert Badges */}
              <div style={{ marginBottom: '1.5rem' }}>
                <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: '0.6rem' }}>
                  Quality Certifications
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
                  {['ISI', 'FSSAI', 'ISO 9001', 'WHO-GMP'].map(cert => (
                    <span key={cert} style={{ background: '#1e293b', color: '#FCD34D', border: '1px solid #334155', borderRadius: '6px', padding: '0.2rem 0.6rem', fontSize: '0.72rem', fontWeight: 700 }}>
                      {cert}
                    </span>
                  ))}
                </div>
              </div>

              {/* Business Hours */}
              <div style={{ background: '#0f172a', borderRadius: '10px', padding: '0.875rem 1rem', border: '1px solid #1e293b' }}>
                <div style={{ marginBottom: '0.3rem' }}>
                  <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>Business Hours</span>
                </div>
                <div style={{ fontSize: '0.8125rem', color: '#94a3b8' }}>Mon – Sun &nbsp;|&nbsp; 6:00 AM – 8:00 PM</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', marginTop: '0.3rem' }}>
                  <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#22c55e', display: 'inline-block' }} />
                  <span style={{ fontSize: '0.76rem', color: '#22c55e', fontWeight: 600 }}>Open Now</span>
                </div>
              </div>
            </div>

            {/* Products Column */}
            <div>
              <h4 style={{ color: 'white', fontWeight: 700, fontSize: '0.9rem', marginBottom: '1.25rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                Our Products
              </h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                {PRODUCT_LINKS.map(pl => (
                  <Link
                    key={pl.to}
                    to={pl.to}
                    style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', textDecoration: 'none', padding: '0.6rem 0.75rem', borderRadius: '8px', background: 'transparent', transition: 'background 0.15s' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#1e293b'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                  >
                    <span style={{ flexShrink: 0, width: 34, height: 34, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <img src={pl.img} alt={pl.label} onError={e => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'inline'; }} style={{ maxWidth: 32, maxHeight: 32, objectFit: 'contain' }} />
                      <span style={{ display: 'none', fontSize: '1.25rem' }} dangerouslySetInnerHTML={{ __html: pl.icon }} />
                    </span>
                    <div>
                      <div style={{ fontSize: '0.84rem', color: '#cbd5e1', fontWeight: 500, lineHeight: 1.2 }}>{pl.label}</div>
                      <div style={{ fontSize: '0.73rem', color: '#FCD34D', fontWeight: 600, marginTop: '0.1rem' }} dangerouslySetInnerHTML={{ __html: pl.desc }} />
                    </div>
                    {pl.tag && (
                      <span style={{ marginLeft: 'auto', background: '#C8171A', color: 'white', borderRadius: '5px', padding: '0.1rem 0.45rem', fontSize: '0.62rem', fontWeight: 700, flexShrink: 0 }}>
                        {pl.tag}
                      </span>
                    )}
                  </Link>
                ))}
                <Link to="/products" style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', color: '#FCD34D', fontSize: '0.84rem', fontWeight: 600, textDecoration: 'none', padding: '0.4rem 0.75rem', marginTop: '0.25rem' }}>
                  View All Products &#8594;
                </Link>
              </div>
            </div>

            {/* Quick Links Column */}
            <div>
              <h4 style={{ color: 'white', fontWeight: 700, fontSize: '0.9rem', marginBottom: '1.25rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                Navigate
              </h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                {[
                  { to: '/', label: 'Home' },
                  { to: '/products', label: 'All Products' },
                  { to: '/about', label: 'About Us' },
                  { to: '/gallery', label: 'Gallery' },
                  { to: '/contact', label: 'Contact' },
                  { to: '/login', label: 'Customer Login' },
                ].map(l => (
                  <Link
                    key={l.to}
                    to={l.to}
                    style={{ color: '#94a3b8', fontSize: '0.875rem', textDecoration: 'none', padding: '0.5rem 0.6rem', borderRadius: '7px', transition: 'all 0.15s', display: 'block' }}
                    onMouseEnter={e => { e.currentTarget.style.background = '#1e293b'; e.currentTarget.style.color = 'white'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#94a3b8'; }}
                  >
                    {l.label}
                  </Link>
                ))}
              </div>
            </div>

            {/* Contact Column */}
            <div>
              <h4 style={{ color: 'white', fontWeight: 700, fontSize: '0.9rem', marginBottom: '1.25rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                Contact Us
              </h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.875rem' }}>
                {[
                  { label: 'Phone', value: '+91 8374422411', href: 'tel:+918374422411', color: '#FCA5A5' },
                  { label: 'WhatsApp', value: '+91 8374422411', href: 'https://wa.me/918374422411', color: '#86efac' },
                  { label: 'Email', value: 'support@vijayavarshi.com', href: 'mailto:support@vijayavarshi.com', color: '#c4b5fd' },
                ].map((c, i) => (
                  <div key={i}>
                    <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em', lineHeight: 1, marginBottom: '0.15rem' }}>{c.label}</div>
                    <a href={c.href} style={{ color: c.color, fontWeight: 600, fontSize: '0.84rem', textDecoration: 'none', display: 'block' }}>{c.value}</a>
                  </div>
                ))}
                <div>
                  <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em', lineHeight: 1, marginBottom: '0.5rem' }}>Factory Address</div>
                  <div style={{ fontSize: '0.78rem', fontWeight: 700, color: '#fdba74', lineHeight: 1.5, marginBottom: '0.25rem' }}>
                    TELANGANA STATE CO-OPERATIVE OIL SEEDS GROWER FEDERATION LTD
                  </div>
                  <div style={{ fontSize: '0.8rem', color: '#94a3b8', lineHeight: 1.7 }}>
                    6-3-192/1/a/8, NH 44, Adarsh Nagar,<br />
                    Shivarampally Jagir, Telangana – 500052
                  </div>
                </div>
              </div>

              {/* Quick Order */}
              <div style={{ marginTop: '1.5rem', background: '#0f172a', borderRadius: '10px', padding: '1rem', border: '1px solid #1e293b' }}>
                <p style={{ fontSize: '0.8125rem', color: '#94a3b8', marginBottom: '0.75rem', lineHeight: 1.5 }}>
                  Need water fast? Call or WhatsApp us for same-day delivery.
                </p>
                <a href="tel:8374422411" style={{ display: 'block', background: '#C8171A', color: 'white', textAlign: 'center', padding: '0.6rem', borderRadius: '8px', fontWeight: 700, fontSize: '0.875rem', textDecoration: 'none' }}>
                  Order Now
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{ borderTop: '1px solid #1e293b', background: '#070f1a' }}>
          <div className="page-container" style={{ padding: '1.25rem 1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.75rem' }}>
            <span style={{ fontSize: '0.8125rem', color: '#cbd5e1' }}>
              &#169; 2024 Vijaya Varshi Water Plant. All rights reserved.
            </span>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                {['ISI', 'FSSAI', 'ISO'].map(c => (
                  <span key={c} style={{ fontSize: '0.7rem', fontWeight: 700, color: '#475569', background: '#0f172a', border: '1px solid #1e293b', borderRadius: '4px', padding: '0.15rem 0.4rem' }}>{c}</span>
                ))}
              </div>
              <span style={{ color: '#FCD34D', fontWeight: 700, fontSize: '0.8125rem' }}>vijayavarshi.com</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
